import { BrowserRouter,Route,Routes} from "react-router-dom";

/* Layout */
import MainLayout from "./layouts/MainLayout";

/* Pages */
import Home from "./pages/Home";
// import Login from "./components/Login";
// import Signup from "./components/Signup";
import CourseDetail from "./components/CourseDetail";

/* Stay */
import Class10 from "./pages/Class10";
import Stay5 from "./pages/Stay5";
import Stay6 from "./pages/Stay6";
import Stay8 from "./pages/Stay8";
import Stay9 from "./pages/Stay9";
import Stay7 from "./pages/Stay7";


/* tutions */
import Class1 from "./pages/Tution/Class1";
import Class2 from "./pages/Tution/Class2";
import Class3 from "./pages/Tution/Class3";
import Class4 from "./pages/Tution/Class4";
import Class5 from "./pages/Tution/Class5";
import Class6 from "./pages/Tution/Class6";
import Class7 from "./pages/Tution/Class7";
import Class8 from "./pages/Tution/Class8";
import Class9 from "./pages/Tution/Class9";

/* Study Material */
import Notes from "./pages/StudyMaterial/Notes";
import PreviousPapers from "./pages/StudyMaterial/PreviousPapers";
import DDPs from "./pages/StudyMaterial/DDPs";

/* Admin */
// import RequestCallback from "./components/RequestCallback";
// import AdminLogin from "./components/AdminLogin";
// import AdminCallbacks from "./components/AdminCallbacks";

// Courses
import Tutions from "./pages/Tutions";
import TestSeries from "./pages/TestSeries";
import StudyMaterial from "./pages/StudyMaterial";

// Company
import AboutUs from "./pages/AboutUs";
import Results from "./pages/Results";
import Hostel from "./pages/Hostel";
import News from "./pages/News";

// Support
import ContactUs from "./pages/ContactUs";
import FAQs from "./pages/FAQs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

// // 🔐 Protected Route
// const AdminRoute = ({ children }) => {
//   const token = localStorage.getItem("adminToken");
//   return token ? children : <Navigate to="/admin/login" />;
// };

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* USER SITE WITH LAYOUT */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/courses/:courseId" element={<CourseDetail />} />

          {/* AUTH */}
          {/* <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} /> */}

          {/* ADMIN */}
          {/* <Route path="/" element={<RequestCallback />} /> */}
          {/* <Route path="/admin/login" element={<AdminLogin />} /> */}
          {/* 🔐 Protected Admin Dashboard */}
          {/* <Route
            path="/admin/callbacks"
            element={
              <AdminRoute>
                <AdminCallbacks />
              </AdminRoute>
            }
          /> */}

          {/* Stay */}
          <Route path="/stay5" element={< Stay5 />}/>
          <Route path="/stay10" element={< Class10 />}/>
          <Route path="/stay6" element={< Stay6 />}/>
          <Route path="/stay7" element={< Stay7 />}/>
          <Route path="/stay8" element={< Stay8 />}/>
          <Route path="/stay9" element={< Stay9 />}/>


          {/* tutions */}
          <Route path="/tution/class1" element={< Class1/>} />
          <Route path="/tution/class2" element={<Class2/>} />
          <Route path="/tution/class3" element={<Class3/>} />
          <Route path="/tution/class4" element={<Class4/>} />
          <Route path="/tution/class5" element={<Class5/>} />
          <Route path="/tution/class6" element={<Class6/>} />
          <Route path="/tution/class7" element={<Class7/>} />
          <Route path="/tution/class8" element={<Class8/>} />
          <Route path="/tution/class9" element={<Class9/>} />

          {/* navbar */}

          {/* Study Material */}
          <Route path="/material/notes" element={<Notes />} />
          <Route path="/material/papers" element={<PreviousPapers />} />
          <Route path="/material/dpps" element={<DDPs />} />
          

          {/* Footer */}
          {/* COURSES */}
          <Route path="/classroom" element={<Tutions />} />
          <Route path="/test-series" element={<TestSeries />} />
          <Route path="/material" element={<StudyMaterial />} />

          {/* COMPANY */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/news" element={<News />} />
          <Route path="/results" element={<Results />} />
          <Route path="/hostel" element={<Hostel />} />

          {/* SUPPORT */}
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;

